import dynamic from 'next/dynamic';
import { OrganizationDetailSidebar } from '~/jobiqo/components/Organization/Detail/Sidebar';
import { OrganizationSubGroups } from '~/jobiqo/components/Organization/OrganizationSubGroups';
import { getMiniSiteJobsPath } from '~/jobiqo/components/Organization/MiniSite/utils';
import { OrganizationAboutWidget } from '~/jobiqo/components/Organization/Widgets/About';
import OrganizationFAQWidget from '~/jobiqo/components/Organization/Widgets/FAQ';
import { OrganizationLocationsWidget } from '~/jobiqo/components/Organization/Widgets/Locations';
import OrganizationBlogPostsWidget from '~/jobiqo/components/Organization/Widgets/BlogPosts';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { OrganizationGalleryPlaceholder } from '~/vcl/organisms/05-placeholders/06-organization/02-gallery';
import styles from '../miniSite.module.scss';
import { OrganizationMiniSiteLayout } from './OrganizationMiniSiteLayout';
import { OrganizationMiniSiteTabs } from './OrganizationMiniSiteTabs';
import type { OrganizationMiniSiteProps } from './types';
import { getMiniSiteMenuItems } from './utils';

const OrganizationGalleryWidget = dynamic(
  () => import('~/jobiqo/components/Organization/Widgets/Gallery'),
  {
    ssr: false,
    loading: () => <OrganizationGalleryPlaceholder />,
  },
);
const OrganizationVideoGalleryWidget = dynamic(
  () => import('~/jobiqo/components/Organization/Widgets/VideoGallery'),
  {
    ssr: false,
    loading: () => <OrganizationGalleryPlaceholder />,
  },
);

export const OrganizationMiniSite = ({
  organization,
  path,
}: OrganizationMiniSiteProps) => {
  const menuItems = getMiniSiteMenuItems(organization);
  const jobsPath = getMiniSiteJobsPath(path);

  return (
    <OrganizationMiniSiteLayout
      organization={organization}
      headerContent={
        <OrganizationMiniSiteTabs
          activeTab="menu"
          homePath={path}
          jobsPath={jobsPath}
          menuItems={menuItems}
        />
      }
    >
      <div
        id="mini_site_panel_menu"
        className={styles.tabPanel}
        role="tabpanel"
      >
        <OrganizationDetailSidebar organization={organization}>
          {/* Home tab content is composed from organization widgets. The
              sidebar component controls the responsive two-column layout. */}
          <OrganizationAboutWidget organization={organization} />
          <Spacing size="large" />
          <OrganizationGalleryWidget organization={organization} />
          <Spacing size="large" />
          <OrganizationVideoGalleryWidget organization={organization} />
          <Spacing size="large" />
          <OrganizationSubGroups organization={organization} />
          <Spacing size="large" />
          <OrganizationFAQWidget organization={organization} />
          <Spacing size="large" />
          <OrganizationBlogPostsWidget
            organization={organization}
            columns={3}
          />
          <Spacing size="large" />
          <OrganizationLocationsWidget organization={organization} />
          <Spacing size="large" />
        </OrganizationDetailSidebar>
      </div>
    </OrganizationMiniSiteLayout>
  );
};
